export enum UrlPathToTab {
  '/main' = 0,
  '/shop' = 1,
  '/unified-profile' = 2,
  '/social' = 3,
  '/tasks' = 4,
}
